import { Link } from "react-router-dom";
import type { GlowPost } from "@/lib/api";

interface ArticleHeroProps {
  post: GlowPost;
}

export default function ArticleHero({ post }: ArticleHeroProps) {
  return (
    <div className="relative w-full" style={{ minHeight: "480px" }}>
      {/* Cover image */}
      <div className="w-full overflow-hidden" style={{ height: "560px" }}>
        <img
          src={post.coverImage}
          alt={post.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-midnight/70 via-midnight/20 to-transparent" />
      </div>

      {/* Overlay content */}
      <div className="absolute inset-0 flex flex-col justify-end pb-14 px-6 lg:px-0">
        <div className="max-w-3xl mx-auto w-full lg:w-[768px]">
          {/* Back link */}
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-moonlight/70 hover:text-moonlight text-xs tracking-widest uppercase transition-colors mb-8 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line" /> The Glow Edit
          </Link>

          {/* Tag + meta */}
          <div className="flex items-center gap-3 mb-4">
            <span className="text-[9px] tracking-widest uppercase bg-moonlight text-midnight px-2.5 py-1">
              {post.tag}
            </span>
            <span className="text-moonlight/50 text-xs">{post.date}</span>
            <span className="text-moonlight/30 text-xs">·</span>
            <span className="text-moonlight/50 text-xs">{post.readTime}</span>
          </div>

          {/* Title */}
          <h1
            className="text-3xl md:text-5xl font-light italic text-moonlight leading-tight mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {post.title}
          </h1>

          {/* Subtitle */}
          <p className="text-moonlight/70 text-sm md:text-base max-w-xl leading-relaxed"
            style={{ fontFamily: "'Jost', sans-serif" }}>
            {post.subtitle}
          </p>
        </div>
      </div>
    </div>
  );
}
